import { FC, useCallback, useEffect, useRef } from "react"
import { SlideNavigationWrapperItem } from "./styles"
import { IThemeSlideColor } from "shared/reducers/ThemeSlideColorSlice";
import { useRouteMatch } from "react-router-dom";
import { AppTester } from "supporting";

export const SlideWithHover: FC<{
    onClick: () => void,
    active: boolean,
    activeIndexKey?: string;
    isLoading?: boolean;
    whiteTheme?: any;
    autoWidth?: boolean;
    autoFlex?: boolean;
    padding?: number;
    whiteSpace?: boolean;
    disableTab?: boolean;
    isTitle?: boolean;
    overflowX?: boolean;
    capitalize?: boolean;
    blueSelect?: boolean;
    item: any;
    onSetActiveTab?: (val: string | null) => void;
    onSetSizes?: (val: any) => void;
    dataName?: string;
    dataTitle?: string;
    isDesigner?: boolean;
    isEmptyProjects?: boolean;
    importantItemColor?: IThemeSlideColor
}> = ({
    onClick,
    active,
    activeIndexKey,
    whiteTheme,
    blueSelect,
    padding,
    whiteSpace,
    disableTab,
    isTitle,
    item,
    onSetSizes,
    onSetActiveTab,
    dataName,
    dataTitle,
    isDesigner,
    isEmptyProjects,
    importantItemColor
}) => {
    const divRef = useRef<HTMLDivElement>(null)
    const isTeamOrCoursePage = !!useRouteMatch(['/teams', '/courses']);
    const isCGRAVE = AppTester.isCGRAVE();
    
    const handleEnter = () => {
        onSetActiveTab && onSetActiveTab(dataName || '')
    };

    const handleLeave = () => {
        onSetActiveTab && onSetActiveTab(null)
    };

    const onItemLoad = useCallback(() => {
        onSetSizes && onSetSizes({
            idx: activeIndexKey, 
            width: divRef?.current?.clientWidth || 0,
            item,
        })
    }, [item, activeIndexKey, onSetSizes, divRef.current])


    useEffect(() => {
        if (!divRef.current) return;
        const resizeObserver = new ResizeObserver(() => {
            onItemLoad()
        });
        resizeObserver.observe(divRef.current);
        return () => resizeObserver.disconnect();
    }, [item, onItemLoad]);

    return (
        <SlideNavigationWrapperItem
            ref={divRef}
            className={"white_theme_project_underline"}
            onClick={onClick}
            active={active}
            white_theme={whiteTheme}
            padding={padding}
            whiteSpace={whiteSpace}
            disableTab={disableTab || isEmptyProjects}
            isTitle={isTitle}
            blueSelect={blueSelect}
            isDesigner={isDesigner}
            {...importantItemColor}
            data-title={dataTitle}
            onMouseEnter={handleEnter}
            onMouseLeave={handleLeave}
            isTeamOrCoursePage={isTeamOrCoursePage}
            isCGRAVE={isCGRAVE}
        >
            {item}
        </SlideNavigationWrapperItem>
    )
}import { FC, useCallback, useEffect, useRef } from "react"
import { SlideNavigationWrapperItem } from "./styles"
import { IThemeSlideColor } from "shared/reducers/ThemeSlideColorSlice";
import { useRouteMatch } from "react-router-dom";
import { AppTester } from "supporting";

export const SlideWithHover: FC<{
    onClick: () => void,
    active: boolean,
    activeIndexKey?: string;
    isLoading?: boolean;
    whiteTheme?: any;
    autoWidth?: boolean;
    autoFlex?: boolean;
    padding?: number;
    whiteSpace?: boolean;
    disableTab?: boolean;
    isTitle?: boolean;
    overflowX?: boolean;
    capitalize?: boolean;
    blueSelect?: boolean;
    item: any;
    onSetActiveTab?: (val: string | null) => void;
    onSetSizes?: (val: any) => void;
    dataName?: string;
    dataTitle?: string;
    isDesigner?: boolean;
    isEmptyProjects?: boolean;
    importantItemColor?: IThemeSlideColor
}> = ({
    onClick,
    active,
    activeIndexKey,
    whiteTheme,
    blueSelect,
    padding,
    whiteSpace,
    disableTab,
    isTitle,
    item,
    onSetSizes,
    onSetActiveTab,
    dataName,
    dataTitle,
    isDesigner,
    isEmptyProjects,
    importantItemColor
}) => {
    const divRef = useRef<HTMLDivElement>(null)
    const isTeamOrCoursePage = !!useRouteMatch(['/teams', '/courses']);
    const isCGRAVE = AppTester.isCGRAVE();
    
    const handleEnter = () => {
        onSetActiveTab && onSetActiveTab(dataName || '')
    };

    const handleLeave = () => {
        onSetActiveTab && onSetActiveTab(null)
    };

    const onItemLoad = useCallback(() => {
        onSetSizes && onSetSizes({
            idx: activeIndexKey, 
            width: divRef?.current?.clientWidth || 0,
            item,
        })
    }, [item, activeIndexKey, onSetSizes, divRef.current])


    useEffect(() => {
        if (!divRef.current) return;
        const resizeObserver = new ResizeObserver(() => {
            onItemLoad()
        });
        resizeObserver.observe(divRef.current);
        return () => resizeObserver.disconnect();
    }, [item, onItemLoad]);

    return (
        <SlideNavigationWrapperItem
            ref={divRef}
            className={"white_theme_project_underline"}
            onClick={onClick}
            active={active}
            white_theme={whiteTheme}
            padding={padding}
            whiteSpace={whiteSpace}
            disableTab={disableTab || isEmptyProjects}
            isTitle={isTitle}
            blueSelect={blueSelect}
            isDesigner={isDesigner}
            {...importantItemColor}
            data-title={dataTitle}
            onMouseEnter={handleEnter}
            onMouseLeave={handleLeave}
            isTeamOrCoursePage={isTeamOrCoursePage}
            isCGRAVE={isCGRAVE}
        >
            {item}
        </SlideNavigationWrapperItem>
    )
}